<template>
  <div>
    <el-dialog
      title="生服平台商家账户转让申请承诺函"
      :visible.sync="jcxy"
      :close-on-click-modal="false"
      width="800px"
      center
    >
      <el-form
        :inline="true"
        ref="addForm"
        :model="reqCreate"
        label-width="120px"
        :rules="rules"
      >
        

        <el-form-item label="签署公司-转让方 " prop="signSealId" class="item">
          <el-select
            v-model="reqCreate.signSealId"
            style="width:620px"
            @change="selectJms"
            clearable
            placeholder="请选择签署公司-转让方 "
            filterable
          >
            <el-option
              v-for="(item, index) in allJMSList"
              :key="index"
              :label="item.companyName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话-转让方" prop="tel">
              <el-input
                v-model="reqCreate.tel"
                style="width:245px"
                clearable
                maxlength="11"
                show-word-limit
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          
        <el-form-item label="签署公司-受让方 " prop="signSealIdBing" class="item">
          <el-select
            v-model="reqCreate.signSealIdBing"
            style="width:620px" 
            clearable
            placeholder="请选择签署公司-受让方 "
            filterable
          >
            <el-option
              v-for="(item, index) in allJMSList"
              :key="index"
              :label="item.companyName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="商家id" prop="sj_id">
              <el-input
                v-model="reqCreate.sj_id"
                style="width:245px"
                clearable
                maxlength="19"
                show-word-limit
                placeholder="请输入商家id"
              ></el-input>
            </el-form-item>
          </el-col>

            <el-col :span="12">
            <el-form-item label="账户名称" prop="account_name">
              <el-input
                v-model="reqCreate.account_name"
                style="width:245px"
                clearable
                maxlength="19"
                show-word-limit
                placeholder="请输入账户名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-form-item label="合同日期" prop="htrq">
            <el-date-picker
              v-model="reqCreate.htrq"
              type="datetime"
              style="width:245px"
              placeholder="请选择合同签署日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jcxy = false">取消</el-button>
        <el-button type="primary" @click="yulan()">预览合同</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="合同生成预览"
      :visible.sync="PDFVisible"
      :close-on-click-modal="false"
      width="900px"
      center
    >
      <iframe
        name="ifram11"
        :src="contractUrl"
        scrolling="auto"
        frameborder="0"
        style="width:870px;height:800px"
      ></iframe>

      <span slot="footer" class="dialog-footer">
        <el-button @click="PDFVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import contract from "@/script/api/contractapi";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data";
export default {
  data() {
    return {
     
    
      id: null,
      jcxy: false,
      PDFVisible: false,
      contractUrl: null,
      allJMSList: [], 

      addField: {},
      singList: [],
      choosePerson: {}, //下拉框所选人
      rules: { 
        signSealId: [
          { required: true, message: "请选择签署公司-转让方", trigger: "blur" }
        ],
        tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        signSealIdBing:[{ required: true, message: "请选择签署公司--受让方", trigger: "blur"}],
        sj_id: [{ required: true, message: "请输入商家id", trigger: "blur" }],
        account_name: [{ required: true, message: "请输入账户名称", trigger: "blur" }],
        htrq: [
          { required: true, message: "请选择合同签订日期", trigger: "change" }
        ]
      },
      reqCreate: {
        xinyongdaima: "",
        htrq: "", 
        sj_id:'',
        account_name:'',

        address: "",
        collectAccount: "",
        collectBankName: "",
        collectUserName: "",
        contractFileId: "",
        contractNo: "",
        createTime: "",
        createUserId: "",
        createUserName: "",
        dateEnd: "",
        dateStart: "",
        feeDate: "",
        fraId: "",
        fraName: "",
        id: "",
        idCard: "",
        jsonData: "",
        processId: "",
        remark: "",
        signName: "",
        signSealId: "",
        signSealIdBing:"",
        state: "",
        storeNumber: "",
        tel: "",
        templateNo: "",
        type: ""
      }
    };
  },
  methods: {
    showDetail() {
      this.getAllJMS(); 
      this.jcxy = true;

      this.reqCreate = {
        xinyongdaima: "",
        htrq: "", 

        address: "",
        collectAccount: "",
        collectBankName: "",
        collectUserName: "",
        contractFileId: "",
        contractNo: "",
        createTime: "",
        createUserId: "",
        createUserName: "",
        dateEnd: "",
        dateStart: "",
        feeDate: "",
        fraId: "",
        fraName: "",
        id: "",
        idCard: "",
        jsonData: "",
        processId: "",
        remark: "",
        signName: "",
        signSealId: "",
        signSealIdBing:'',
        state: "",
        storeNumber: "",
        tel: "",
        templateNo: "",
        type: ""
      };
    },
    selectJms(id) {
      if (id == null || id == "") {
        this.choosePerson = {};
        this.reqCreate.fraId = "";
        this.reqCreate.xinyongdaima = "";
        this.reqCreate.tel = "";
        this.reqCreate.address = "";
      }
      if (id != null) {
        let ren = {};
        this.allJMSList.forEach(e => {
          if (e.id == id) {
            ren = e;
          }
        });
        this.choosePerson = ren;
        this.reqCreate.fraId = ren.franchiseeId;
        this.reqCreate.xinyongdaima = ren.creditCode;
        this.reqCreate.tel = ren.tel;
        console.log(ren);
        this.reqCreate.address = ren.address;
      }
    },
    fillTemplate() {
      let addField = {
        // xinyongdaima: this.reqCreate.xinyongdaima,
        // address: this.reqCreate.address,
        // tel: this.reqCreate.tel,

        // year: this.reqCreate.dateStart.substring(0, 4),
        // month: this.reqCreate.dateStart.substring(5, 7) * 1,
        // day: this.reqCreate.dateStart.substring(8, 10) * 1,

        yi_taitou:this.choosePerson.companyName,
        jia_taitou: '上海宅尔保洁服务有限公司',  
        riqi:this.reqCreate.htrq,
        sj_id:this.reqCreate.sj_id,
        account_name:this.reqCreate.account_name
        
      };
      this.addField = addField;
      return addField;
    },
    yulan() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          let temFields = this.fillTemplate();
          this.reqCreate.tempSignData = temFields;

          let reqData = {
            // cityId: this.reqCreate.cityId,
            fraId: this.reqCreate.fraId,
            eventType: 226,
            name: "生服平台商家账户转让申请承诺函",
            simpleFormFields: temFields
          };

          const loading = this.$loading({
            lock: true,
            text: "努力生成中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.5)"
          });

          contract
            .$ajaxPreviewFile(reqData)
            .then(res => {
              if (res.data.errno == 0) {
                loading.close();
                // console.log(res);
                this.contractUrl = res.data.data.downloadUrl;
                this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                this.PDFVisible = true;
              } else {
                loading.close();
                this.$message({
                  showClose: true,
                  message: res.data.data,
                  type: "warning",
                  duration: 8000
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    sendContractBtn() {
      const loading = this.$loading({
        lock: true,
        text: "发送合同中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      });

      this.reqCreate.fraId = globalData.franchisee.id;
      this.reqCreate.createUserId = this.reqCreate.fraId; // globalData.userInfo.id;
      this.reqCreate.createUserName = globalData.userInfo.userName;
      this.reqCreate.type =226;

      contract.$ajaxJmsSignContract(this.reqCreate).then(res => {
        loading.close();
        if (res.data.errno == 0) {
          this.$message.success("合同已发送！");
          // this.querySearch();
          this.$emit("querySearch");
          this.PDFVisible = false;
          this.jcxy = false;
        } else {
          this.$message.warning(res.data.data);
        }
      });
    },
    getAllJMS() {
      //城市下拉框
      contract.$ajaxJmsgetJMSAll().then(res => {
        if (res.data.errno == 0) {
          this.allJMSList = res.data.data;
        }
      });
    },
 
  }
};
</script>
<style lang="">
.item .el-form-item__label {
  color: #f56c6c;
  font-weight: bold;
  font-size: 10px;
}

.nian .el-form-item__label {
  font-size: 11px;
}
</style>
